<template>

    <div class="common-layout">
        <el-container>
            <header class="hero">
                <!-- 顶部：双语标题 -->
                <div class="hero-title">
                    <div class="cn">中国特色大国外交多语种、多模态语料库</div>
                    <div class="en">A MULTILINGUAL AND MULTIMODAL CORPUS OF CHINA'S MAJOR-COUNTRY DIPLOMACY</div>
                </div>

                <!-- 底部：导航栏（无搜索框） -->
<!--                <el-menu-->
<!--                    class="hero-menu"-->
<!--                    mode="horizontal"-->
<!--                    :default-active="activeIndex"-->
<!--                    :background-color="menuBg"-->
<!--                    text-color="#fff"-->
<!--                    active-text-color="#ffd04b"-->
<!--                    @select="handleSelect"-->
<!--                >-->
<!--                    &lt;!&ndash; 左侧占位，让导航靠右；若想居中，去掉这两项和 hero-menu 的 justify-content 设置 &ndash;&gt;-->
<!--                    <div class="menu-spacer" ></div>-->

<!--&lt;!&ndash;                    <el-menu-item index="about">&ndash;&gt;-->
<!--&lt;!&ndash;                        <a href="http://www5.zzu.edu.cn/fld/" target="_blank" rel="noopener">关于我们</a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="zx"><a @click.prevent="goLogin">语料库资讯</a></el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="zs"><a @click.prevent="goLogin">语料库知识</a></el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="cy"><a @click.prevent="goLogin">常用语料库</a></el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="gj"><a @click.prevent="goLogin">语料库工具</a></el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="wx"><a @click.prevent="goLogin">研究文献</a></el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-menu-item index="fx"><a @click.prevent="goLogin">语料分享</a></el-menu-item>&ndash;&gt;-->
<!--                    <el-menu-item index="login"><a @click.prevent="goLogin">登录</a></el-menu-item>-->
<!--                    <el-menu-item index="register"><a @click.prevent="goRegister">注册</a></el-menu-item>-->
<!--                </el-menu>-->
                <el-menu
                    class="hero-menu"
                    mode="horizontal"
                    :default-active="activeIndex"
                    :background-color="menuBg"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    @select="handleSelect"
                >
                    <!-- 左侧占位，让导航靠右；这块居中效果用justify-content -->
                    <div class="menu-spacer"></div>

                    <!-- 仅剩下登录和注册 -->
                    <el-menu-item index="login"><a @click.prevent="goLogin">登录</a></el-menu-item>
                    <el-menu-item index="register"><a @click.prevent="goRegister">注册</a></el-menu-item>
                </el-menu>

                <!-- 放在导航栏 <el-menu> 后面 -->
                <!-- 放在导航栏后 -->
                <div class="search-bar" style="margin-top: 30px; margin-bottom: 40px">
                    <el-input
                        v-model="searchText"
                        placeholder="请输入关键词"
                        prefix-icon="el-icon-search"
                        clearable
                        class="search-input"
                        @keyup.enter="onSearch"
                    >
                        <template #append>
                            <el-button class="search-btn" @click="onSearch">搜索</el-button>
                        </template>
                    </el-input>
                </div>
            </header>


<!--            <h1 style="color: black;text-align: center;font-size: 40px; font-style: normal; color: #ff253a">欢迎访问中国特色大国外交多语种、多模态语料库！</h1>-->
            <h1 style="text-align: center; font-size: 36px; font-weight: 600; color: #ff253a; margin: 20px 0; margin-top: 50px">
              <span style="font-size: 28px; color: #409EFF; cursor: pointer; margin-right: 8px;">
                <i class="el-icon-location-outline"></i>
                网站首页
              </span>

              <span style="color:#ff253a; ">欢迎访问郑州大学中国特色大国外交多语种、多模态语料库！</span>
            </h1>
            <!-- 放在头部下面 -->
            <section class="promo-wrap">
                <!-- 左侧竖直按钮 -->
                <div class="promo-left">
                    <el-button class="side-btn side-btn--orange" @click="openExternal">
                        语料库
                    </el-button>
                    <el-button class="side-btn side-btn--blue" @click="openInternal">
                        内部链接
                    </el-button>
                </div>

                <!-- 中间两块红色胶囊卡片 -->
                <div class="promo-center">
                    <div class="pill-card" @click="goCorpus">
                        中国特色大国外交多语种、多模态语料库
                    </div>

                    <div class="center-divider"></div>

<!--                    <div class="pill-card" @click="goAcademic">-->
<!--                        中国特色大国外交多语种、多模态<br/>术语库-->
<!--                    </div>-->
                </div>

                <!-- 右侧人物图片 -->
                <div class="promo-right" @click="goToDigitalHuman">
                    <div class="promo-figure">
                        <img
                            class="promo-img"
                            src="../xiaoyu2.jpg"
                            alt="多语种AI主播小豫"
                        />
                        <div class="promo-caption">多语种AI主播“小豫”</div>
                    </div>
                </div>
            </section>



            <!--            <el-menu-->
<!--                    :default-active="activeIndex2"-->
<!--                    class="el-menu-demo"-->
<!--                    mode="horizontal"-->
<!--                    background-color="#545c64"-->
<!--                    text-color="#fff"-->
<!--                    active-text-color="#ffd04b"-->
<!--                    @select="handleSelect">-->
<!--&lt;!&ndash;                <el-menu-item index="5" >&ndash;&gt;-->
<!--&lt;!&ndash;                    <a style="font-size: 25px">中国特色大国外交多语种、多模态语料库</a>&ndash;&gt;-->
<!--&lt;!&ndash;                </el-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-menu-item index="5" >&ndash;&gt;-->
<!--&lt;!&ndash;                    <a style="font-size: 25px">A MULTILINGUAL AND MULTIMODAL CORPUS OF CHINA'S MAJOR-COUNTRY DIPLOMACY</a>&ndash;&gt;-->
<!--&lt;!&ndash;                </el-menu-item>&ndash;&gt;-->
<!--                <div style="margin-left: auto; display: flex;">-->
<!--                    <el-menu-item index="4">-->
<!--                        <a href="http://www5.zzu.edu.cn/fld/">关于我们</a>-->
<!--                    </el-menu-item>-->
<!--                    <el-menu-item index="1">-->
<!--                        <a @click="goLogin">登录</a>-->
<!--                    </el-menu-item>-->
<!--                    <el-menu-item index="2">-->
<!--                        <a @click="goRegister">注册</a>-->
<!--                    </el-menu-item>-->
<!--                </div>-->

<!--            </el-menu>-->




            <el-main>
<!--                <el-carousel :interval="4000" type="card" height="400px">-->
<!--                    <el-carousel-item v-for="(image, index) in images" :key="index">-->
<!--                        <img :src="image" alt="Carousel Image" style="width: 100%; height: 100%; object-fit: cover;">-->
<!--                    </el-carousel-item>-->
<!--&lt;!&ndash;                    <el-carousel-item v-for="item in 6" :key="item">&ndash;&gt;-->
<!--&lt;!&ndash;                        <h3 class="medium">{{ item }}</h3>&ndash;&gt;-->
<!--&lt;!&ndash;                    </el-carousel-item>&ndash;&gt;-->
<!--                </el-carousel>-->

<!--                <h1 style="color: black;text-align: center;font-size: 40px; font-style: normal; color: #ff253a">欢迎访问中国特色大国外交多语种、多模态语料库！</h1>-->




<!--                <span class="box" style="margin-left: 260px; margin-right: 20px;">-->

<!--                    <el-link type="primary" style="text-align: center; color: black; font-size: 30px" href="#">中国特色大国外交多语种、多模态语料库</el-link>-->
<!--                </span>-->

<!--                <span class="box" style="margin-left: 140px; margin-right: 20px;">-->
<!--                    <el-link type="primary" style="text-align: center; color: black; font-size: 30px" href="#">中国特色大国外交多语种术语库</el-link>-->
<!--                </span>-->

            </el-main>

            <el-footer>
                <!--页脚内容-->
                <el-descriptions class="margin-top" :column="3" :size="size" border>
                    <el-descriptions-item>
                        <template #label>
                            <div class="cell-item">
                                <el-icon :style="iconStyle">
                                    <user />
                                </el-icon>
                                网站归属
                            </div>
                        </template>
                        郑州大学中国外交话语研究院 Chinese Academy of Diplomatic Discourse Studies
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="cell-item">
                                <el-icon :style="iconStyle">
                                    <iphone />
                                </el-icon>
                                电话
                            </div>
                        </template>
                        （0371） 67781220/ 67781652/ 67780959
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="cell-item">
                                <el-icon :style="iconStyle">
                                    <location />
                                </el-icon>
                                地区
                            </div>
                        </template>
                        郑州
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="cell-item">
                                <el-icon :style="iconStyle">
                                    <tickets />
                                </el-icon>
                                Remarks
                            </div>
                        </template>
                        <el-tag size="small">School</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="cell-item">
                                <el-icon :style="iconStyle">
                                    <office-building />
                                </el-icon>
                                地址
                            </div>
                        </template>
                        河南省郑州市中原区科学大道100号
                    </el-descriptions-item>
                </el-descriptions>
            </el-footer>
        </el-container>
    </div>

</template>

<script>
import TopMenuVue from '@/components/TopMenu.vue';
import {Document, HomeFilled, Notebook, User, Files, Picture, Link} from "@element-plus/icons-vue"
export default {
    name: "index",
    data(){
        return {
            images: [
                require('@/assets/images/Carousel_Picture1.jpg'),
                require('@/assets/images/Carousel_Picture2.jpg'),
                require('@/assets/images/Carousel_Picture3.jpg'),
                require('@/assets/images/Carousel_Picture4.jpg'),
                require('@/assets/images/Carousel_Picture5.jpg'),
                require('@/assets/images/Carousel_Picture6.jpg'),
            ],
            searchText: ''
        }
    },
    methods:{
        goLogin(){
            this.$router.push({name:"login"})

        },
        goRegister(){
            this.$router.push({name:"register"})
        },
        onSearch() {
            if (!this.searchText.trim()) {
                this.$message.warning('请输入搜索关键词');
                return;
            }
            // 弹出提示框
            this.$alert('搜索功能暂未开放 敬请期待!', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            // 可选：清空输入框
            this.searchText = '';
        },
        goToDigitalHuman() {
            // window.open('/english/digital_human.html', '_blank');
            // this.$router.push({name:"xiaoyunew"})
            window.open(`${process.env.BASE_URL}xiaoyu-digital.html`, '_blank');
        }

    },
    components:{
        TopMenuVue,
    }
}
</script>



<style scoped>
     /* 背景与整体间距调小，避免大片留白 */
 .hero {
     /*margin-top: 80px;*/
     background: #a3201b;
     padding: 20px 24px 6px;
 }

     .hero-title {
         margin-top: 80px;
         max-width: 2400px;
         margin: 0 auto 8px;
         text-align: center;
         line-height: 1.3;
     }

     .hero-title .cn {
         margin-top: 80px;
         max-width: 1400px;
         font-size: 42px;       /* 固定字号 */
         font-weight: 700;
         margin-bottom: 6px;
         margin-left: 400px;
         color: #FF9B00;
         background: #a3201b;
     }

     .hero-title .en {
         /*margin-top: 80px;*/
         font-size: 22px;       /* 固定字号 */
         font-weight: 500;
         margin-left: 400px;
         /*text-transform: uppercase;*/
         /*opacity: 0.92;*/
         /*margin: 0 auto;*/
         color: #FF9B00;
         background: #a3201b;
     }

    /* 关键：让 el-menu 自己当 flex 容器来对齐 */
    /* 居右：flex-end；若想居中 -> 改成 center */
    .hero-menu {
        max-width: 1200px;
        margin: 0 auto;
        display: flex !important;
        justify-content: center;   /* 改成 center 可居中 */
        align-items: center;
        border-bottom: none;
        background: transparent !important;
    }

    /* 链接与间距 */
    .hero-menu ::v-deep .el-menu-item {
        padding: 0 14px;
        height: 52px;
        line-height: 52px;
    }

    .hero-menu a {
        color: #FF9B00;
        font-size: 15px;
        text-decoration: none;
    }

    .hero-menu a:hover { opacity: 0.92; }
    .hero-menu ::v-deep .is-active > a { color: #ffd04b; }



     /* ===== 底部三栏布局 ===== */
     .promo-wrap {
         max-width: 1200px;
         margin: 18px auto 0;
         display: grid;
         grid-template-columns: 180px 1fr 220px; /* 左-中-右 */
         gap: 24px;
         align-items: center;
     }

     .promo-left {
         display: flex;
         flex-direction: column;
         gap: 16px;
         align-items: center; /* 让两个按钮居中对齐 */
     }

     /* 公共样式：保证统一大小与居中 */
     .side-btn {
         width: 160px;        /* 固定宽度，两个按钮完全一样 */
         height: 56px;        /* 固定高度 */
         font-size: 18px;
         font-weight: 700;
         color: #fff;
         border: none;
         border-radius: 10px;
         display: flex;        /* 用 flex 让文字居中 */
         align-items: center;
         justify-content: center;
         box-shadow: 0 2px 0 rgba(0,0,0,.15), inset 0 1px 0 rgba(255,255,255,.25);
         cursor: pointer;
         transition: transform .1s ease, filter .1s ease;
     }

     .side-btn:hover {
         filter: brightness(1.05);
     }
     .side-btn:active {
         transform: translateY(1px);
     }

     /* 单独颜色渐变 */
     .side-btn--orange {
         background: linear-gradient(180deg, #ffa24d, #ff6a00);
     }

     .side-btn--blue {
         background: linear-gradient(180deg, #66c3ff, #3c8dcf);
         margin-right: 12px;
     }
     .side-btn:hover { filter: brightness(1.05); }
     .side-btn:active { transform: translateY(1px); }

     /* 中间区域：改成 flex 布局 */
     .promo-center {
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 28px; /* 卡片与分隔线之间间距 */
     }

     /* 红色胶囊卡片 */
     .pill-card {
         flex: 1;                 /* 自动均分可用空间 */
         /*min-width: 320px;        !* 保证足够宽 *!*/
         min-width: 400px;        /* 保证足够宽 */
         background: #a3201b;     /* 与顶部红色一致 */
         color: #FF9B00;
         border-radius: 14px;
         padding: 20px 24px;
         text-align: center;
         /*font-size: 20px;*/
         font-size: 32px;
         font-weight: 700;
         /*line-height: 1.35;*/
         line-height: 3.2;
         box-shadow: 0 4px 12px rgba(0,0,0,.08);
         cursor: pointer;
         transition: transform .12s ease, box-shadow .12s ease, filter .12s ease;
     }
     .pill-card:hover {
         transform: translateY(-1px);
         box-shadow: 0 8px 20px rgba(0,0,0,.12);
         filter: brightness(1.03);
     }

     /* 中间分隔线 */
     .center-divider {
         width: 1px;
         background: rgba(0,0,0,.08);
         height: 70px;
     }

     /* 右侧图片 */
     .promo-right {
         display: flex;
         justify-content: flex-end;
         align-items: center;
     }


     /* 让图片与标题垂直居中排布并居中对齐 */
     .promo-figure {
         display: flex;
         flex-direction: column;
         align-items: center;
     }

     /* 图片保持原有大小设置，这里确保是块级、可居中 */
     .promo-img {
         display: block;
         max-width: 100%;
         height: 160px;        /* 你已有的高度，可按需调整 */
         object-fit: contain;
         border-radius: 8px;
     }

     /* 图片下方说明文字样式 */
     .promo-caption {
         margin-top: 2px;      /* 与图片的间距 */
         font-size: 18px;
         color: #000000;          /* 可改为 #666/#999 等 */
         line-height: 1.4;
         /*font: bold;*/
         text-align: center;
         white-space: nowrap;  /* 不想换行就保留；想自动换行可删掉 */
     }


     .search-bar{
         background:#a3201b;
         padding:20px 0;
         display:flex;
         justify-content:center;
     }
     .search-input{
         width:80%;
         max-width:800px;
     }

     /* 关键：把追加区的内边距清掉，按钮贴合输入框 */
     .search-input ::v-deep .el-input-group__append{
         padding:0;
         border:none;
     }

     /* 按钮样式 */
     .search-btn{
         background:#000;
         color:#fff;
         border:none;
         font-weight:600;
         padding:0 24px;
         height:40px;             /* 与输入框高度一致 */
         border-radius:0 6px 6px 0;
     }
     .search-btn:hover{ background:#000; color:#fff; }




     .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}
.box {
    width: 100px; /* 方框的宽度 */
    height: 100px; /* 方框的高度 */
    background-color: transparent; /* 方框的背景颜色 */

    /*border: 1px solid #000; !* 方框的边框 *!*/
    margin: 10px; /* 方框的外边距 */
    padding: 10px; /* 方框的内边距 */
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2); /* 方框的阴影效果 */
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>